module.exports = __webpack_public_path__ + "img/sensor_de_vision.b0bacb2a.jpg";